import {useMutation} from "@apollo/client";
import {LoginUser} from "../GraphQL/LoginMutations";
import React, {ChangeEvent, useEffect} from "react";
import {toast} from "react-toastify";
import {useAppDispatch} from "../redux/hooks";
import {setUser} from "../redux/slices/user/userSlice";
import Button from "../Atoms/Button";
import Input from "../Atoms/Input";
import {LoadingScreen} from "../Atoms/LoadingScreen";
import {setActiveContent, setIsAppLoading} from "../redux/slices/content/contentSlice";
import {ActiveContent} from "../redux/slices/content/contentType";

export const Login = (props: {}) => {
    const dispatch = useAppDispatch();

    const [userName, setUserName] = React.useState<string>("");
    const [password, setPassword] = React.useState<string>("");

    const [loginUser, { data: loginData, error: loginError, loading: loginLoading }] = useMutation(LoginUser);

    useEffect(() => {
        if (loginData && !loginLoading) {
            localStorage.setItem('token', loginData.login.token)
            dispatch(setUser({
                userEmail: loginData.login.user.userEmail,
                role: loginData.login.user.userRole,
                userName: loginData.login.user.userName,
                userId: loginData.login.user.userId,
                lastPlayedAdventure: loginData.login.user.lastPlayedAdventure,
                lastHostedAdventure: loginData.login.user.lastHostedAdventure
            }))
        }
    }, [loginData])

    useEffect(() => {
        if (loginError) {
            toast('Falsches Passwort');
            setPassword('')
        }
    }, [loginError])

    useEffect(() => {
        dispatch(setIsAppLoading({
            isAppLoading: loginLoading,
            loadingText: loginLoading? 'Sie werden angemeldet' : ''
        }))
    }, [loginLoading])

    const handleLogin = async () => {
        await loginUser({
            variables: {
                userName: userName,
                userPassword: password
            }
        })
        toast('Erfolgreich');
    }


    return (
        <div className='row login-container'>
            <div className='col-5 login-left-container'>
                <div className='login-left-container-logo'>
                    <div className='col-5'>VENE DND</div>
                </div>
            </div>
            <div className='col-7 login-right-container'>
                <div className='row justify-content-center align-content-center' style={{ height: 'calc(100vh - 20px)' }}>
                    <div className='col-10 login-right-inner-container'>
                        <div className='row'>
                            <h3>Login</h3>
                        </div>
                        <div className='row mt-4 justify-content-center'>
                            <div className='col-10'>
                                <Input
                                    label='Benutzername:'
                                    onChange={ (event: ChangeEvent<HTMLInputElement>) => setUserName(event.target.value) }
                                    onKeyDown={ async (event: any) => {
                                        if (event.key === 'Enter') {
                                            await handleLogin()
                                        }
                                    }}
                                    value={userName}
                                />
                            </div>
                        </div>
                        <div className='row justify-content-center'>
                            <div className='col-10'>
                                <Input
                                    label='Passwort'
                                    onChange={ (event: ChangeEvent<HTMLInputElement>) => setPassword(event.target.value)}
                                    value={password}
                                    onKeyDown={ async (event: any) => {
                                        if (event.key === 'Enter') {
                                            await handleLogin()
                                        }
                                    }}
                                    type='password'
                                />
                            </div>
                        </div>
                        <div className='row justify-content-center mt-3'>
                            <div className='col-6'>
                                <Button
                                    className='login-btn'
                                    onClick={ handleLogin }
                                >
                                    <span>Anmelden</span>
                                </Button>
                            </div>
                        </div>
                        <div className='row justify-content-center mt-2'>
                            <div className='col-6'>
                                <Button
                                    onClick={ async () => dispatch(setActiveContent(ActiveContent.Registrierung)) }
                                >
                                    <span>Zur Registrierung</span>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}